export default {
  25000: '无效的参数',
  25001: '页面没找到',
  25002: 'Mongo连接错误',
  25003: 'Mongo写入错误',
  25004: 'Mongo读取错误',
  25005: '第三方服务错误',
  25006: 'HTTP错误',
  25007: '解码错误',
  25008: '不合法参数',

  25009: '后台配置出错',
  25010: '上传文件出错',
  25011: '下载文件出错',
  25012: 'Git操作错误',
  25013: '生成ID出错',
  25014: '无数据权限',
  25015: '内部错误',

  25100: '系统不存在',
  25101: '已存在该小程序名称',
  25102: '已存在该微信appid',
  25103: '已存在该仓库Group',
  25104: '该供应商没有git账号',
  25320: 'CreateModule_GroupId_NotInDB',
  25321: '小程序不存在',
  25322: '请先创建主模块，后创建子模块',
  25323: '该小程序已存在一个主模块',
  25324: '无效的供应商',
  25325: '该小程序下已存在该模块名',
  25362: '已存在该微信APPID',

  25340: '小程序不存在',
  25360: '小程序名重复',
  25361: '找不到该小程序ID',
  25400: '模块不存在',
  25420: '模块不存在',
  25440: '小程序不存在',
  25460: '已存在审核中版本',
  25480: '不存在审核中版本',
};
